module.exports = __webpack_public_path__ + "static/media/cliente.68d8d676.svg";